import Button from "@components/ui/button";
import { IconX } from "@tabler/icons-react";
import { createPortal } from "react-dom";

/**
 * Viewport-fixed close control, portaled to `document.body`.
 *
 * The portal is the point: a plain `fixed` element inside a dialog is trapped
 * by the first ancestor with a transform/filter, so it lands in the modal's
 * corner rather than the viewport's. Portaling escapes that (and any overflow
 * clipping), keeping every modal's close button in the same place.
 */
export const PortalCloseButton = ({
  onClick,
  disabled,
}: {
  onClick: () => void;
  /** Blocks the close while a completion the user just triggered is in flight. */
  disabled?: boolean;
}) => {
  if (typeof document === "undefined") return null;

  return createPortal(
    <Button
      variant="secondary"
      aria-label="Close"
      onClick={onClick}
      disabled={disabled}
      className="tw-fixed tw-right-6 tw-top-6 tw-z-[10001] tw-size-9 tw-rounded-full tw-p-0 tw-text-blue-500 tw-shadow-sm tw-outline tw-outline-1 tw-outline-offset-0 tw-outline-blue/5 disabled:tw-opacity-50 [&_svg]:tw-fill-none"
    >
      <IconX size={16} stroke={1} />
    </Button>,
    document.body,
  );
};
